export const variables = {
  colNameMapFor3: {
    1: 'A',
    2: 'B',
    3: 'C',
  },
}